
import isClient from '@/mixins/isClient'
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  mixins: [ogPagesMixins, isClient],
  scrollToTop: true,
  props: {
    author: {
      type: Object,
      default: null,
    },
    statistics: {
      type: Object,
      default: null,
    },
    seoAuthorName: {
      type: String,
      default: '',
    },
    activeTariff: {
      type: String,
      default: 'STANDART',
    },
  },
  data() {
    return {
      seoType: 'profile',
      popularOffers: null,
      posts: null,
      postsLimit: 10,
      postsOffset: 0,
      postsCount: 0,
    }
  },
  async fetch() {
    if (this.author) {
      await Promise.all([this.fetchPosts(), this.fetchPopularOffer()])
    }
  },
  computed: {
    isVisibleAuthorOffers() {
      return this.activeTariff === 'PREMIUM'
    },
    isVisibleExclusive() {
      return this.activeTariff === 'PLUS' || this.activeTariff === 'PREMIUM'
    },
    isAuthor() {
      if (this.$auth.loggedIn && this.author) {
        return this.$auth?.user?._id === this.author.id
      } else {
        return false
      }
    },
    additionalMeta() {
      if (this.author?.type === 'USER') {
        return [
          {
            hid: 'profile:first_name',
            property: 'profile:first_name',
            content: this.author?.profile?.firstName,
          },
          {
            hid: 'profile:last_name',
            property: 'profile:last_name',
            content: this.author?.profile?.lastName,
          },
          {
            hid: 'profile:username',
            property: 'profile:username',
            content: this.author?.username,
          },
        ]
      } else {
        return [
          {
            hid: 'profile:username',
            property: 'profile:username',
            content: this.author?.username,
          },
        ]
      }
    },
    seoImage() {
      return {
        url: `https://api.megasreda.ru/image/ogimage/author/${this.author?.id}.jpg`,
        urlVk: `https://api.megasreda.ru/image/ogimage/author/vk/${this.author?.id}.jpg`,
        urlTw: `https://api.megasreda.ru/image/ogimage/author/${this.author?.id}.jpg`,
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      }
    },
    seoH1() {
      let sectors = []
      if (this.author?.userSectors?.length) {
        sectors = this.author.userSectors
          .map((sector) => `, ${sector.title}`)
          .join('')
      }
      let offers = []
      if (this.popularOffers?.length) {
        offers = this.popularOffers
          .map((product) => `, ${product.title}`)
          .join('')
      }
      return `${this.seoAuthorName}${sectors}, сайт ${
        this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
      }, поддержка, контакты${offers}`
    },
    seoTitle() {
      return `${this.seoAuthorName} | Мегасреда`
    },
    seoDescription() {
      if (this.author?.profile?.description) {
        return `${this.author.profile.description}${
          !this.author.profile.description.endsWith('.') ? '.' : ''
        } Все свежие новости, рейтинги и контакты ${
          this.author?.type === 'COMPANY' ? 'компании' : 'пользователя'
        } ${this.seoAuthorName}`
      } else {
        return `Все свежие новости, рейтинги и контакты ${
          this.author?.type === 'COMPANY' ? 'компании' : 'пользователя'
        } ${this.seoAuthorName}`
      }
    },
  },
  methods: {
    isTelegram(article) {
      return article.type === 'telegram'
    },
    isVideo(article) {
      return article.type === 'video'
    },
    loadMore() {
      this.postsOffset = this.postsOffset + this.postsLimit
      this.fetchPosts()
    },

    updatePost() {
      this.posts = null
      this.$fetch()
      this.$emit('update-post')
    },
    removePost() {
      this.posts = null
      this.$fetch()
      this.$emit('remove-post')
    },

    async fetchPosts() {
      if (this.author) {
        const { articles, countAllPublishedArticles } = await this.$axios.$get(
          `/review/${this.author.id}`,
          {
            params: {
              limit: this.postsLimit,
              offset: this.postsOffset,
            },
          }
        )

        this.postsCount = countAllPublishedArticles
        if (this.posts?.length) {
          this.posts = this.posts.concat(articles)
        } else {
          this.posts = articles
        }
      }
    },

    async fetchPopularOffer() {
      const { products } = await this.$axios.$get(
        `/advertisements/products/${this.author.id}/popular`,
        {
          params: {
            limit: 1,
          },
        }
      )
      this.popularOffers = products
    },

    updateProduct() {
      this.popularOffers = null
      this.fetchPopularOffer()
    },
    removeProduct() {
      this.popularOffers = null
      this.fetchPopularOffer()
    },
  },
}
